import Icon from '../components/Icon';

const PlaceMountainFilled = Icon(
  'place-mountain-filled',
  <>
    <path d="M14.049 3.268c.565-1.573 2.804-1.534 3.314.057l5.142 16.043A1.25 1.25 0 0 1 21.315 21h-9.291l-.015.001H2.706c-.86 0-1.465-.85-1.18-1.664L5.414 8.256c.535-1.523 2.67-1.572 3.275-.075l1.058 2.625-3.12 8.694h1.594l2.37-6.603v.002z" />
  </>
);

export default PlaceMountainFilled;
